import Button from '../CustomButton/CustomButton'
import React from 'react';
import { FormattedMessage } from 'react-intl';

//<i className="fa fa-lg fa-list margin-right-5"></i>

// const ExportButton = (props) => (
//   <Button {...props} icon wd bsStyle="primary" >
//     <i className="fa fa-lg fa-file-excel-o margin-right-5"></i>
//     <FormattedMessage
//       id='ids_export'
//       defaultMessage='Exporter'/>
//   </Button>
// );

// export { ExportButton };


import _ from "lodash";

class ExportButton extends React.Component {
  constructor(props) {
    super();

    this.state = {
      // used to register working state during the debounce delay only
      workInProgressLocal: false
    };
  }

  onClick = value => {
    !!!this.props.workInProgress &&
      this.props.onClick &&
      this.props.onClick(value);
    this.setState({ workInProgressLocal: false });
  };

  // debouncedonMouseDown = _.debounce(this.onMouseDown, 20);
  debouncedonClick = _.debounce(this.onClick, 100);

  render = () => {
    return (
      <Button
        {...this.props}
        onClick={value => {
          this.setState({ workInProgressLocal: true });
          this.debouncedonClick(value);
        }}
        disabled={
          this.props.disabled ||
          this.props.workInProgress ||
          this.state.workInProgressLocal
        }
        icon
        wd
        fill
        bsStyle="primary"
      >
        {this.props.workInProgress || this.state.workInProgressLocal ? (
          <i className="fa fa-lg fa-spinner fa-spin margin-right-5" />
        ) : (
          <i className="fa fa-lg fa-file-excel-o margin-right-5" />
        )}
        <FormattedMessage id="ids_export" />
      </Button>
    );
  };
}

export { ExportButton };
